<template>
  <v-dialog v-model="show" max-width="400" content-class="rounded-xl">
    <v-card>
      <v-card-title class="headline d-flex justify-center">
        Выход из системы
      </v-card-title>
      <v-card-text class="subtitle-1">
        Вы уверены, что хотите выйти? <br />
        Все несохранённые изменения будут потеряны.
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn
          color="green lighten-1"
          fab
          text
          @click.stop="show = false"
          @click="logout"
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn color="red lighten-1" fab text @click.stop="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapActions } from "vuex";

export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      dialog: this.$store.getters.getExitDialog,
    };
  },

  methods: {
    ...mapActions(["setMenu"]),
    logout: function () {
      // localStorage.removeItem("token");
      this.$store
        .dispatch("logout")
        .then(() => {
          // console.log("logout");
        })
        .catch((err) => console.log(err));
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>